import { FaWhatsapp } from 'react-icons/fa';
import MessageBubble from './MessageBubble';

// Prévia estilo WhatsApp (com cabeçalho de conversa) para o editor. A bolha em
// si vem do MessageBubble (mesma renderização usada nos cards).
export default function ChatPreview({ text }) {
  return (
    <div style={frame}>
      <div style={topbar}>
        <div style={avatar}><FaWhatsapp size={16} /></div>
        <div style={{ lineHeight: 1.2 }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>MenuCheff Bot</div>
          <div style={{ fontSize: 11, opacity: 0.85 }}>online</div>
        </div>
      </div>
      <div style={{ padding: 12 }}>
        <MessageBubble text={text} />
      </div>
    </div>
  );
}

const frame = { borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,0,0,0.12)', background: '#efeae2' };
const topbar = { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: '#075e54', color: '#fff' };
const avatar = { width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.2)' };
